module.exports = __webpack_public_path__ + "img/center_item_person.ed81fff0.png";